<mat-list-item>
	<div class="mat-list-content">
		<h4 matLine>{{ filename }}</h4>
		<a matLine>{{ size|byteFormat }}</a>
	</div>
	<button mat-icon-button (click)="deletePhoto()">
		<mat-icon>delete</mat-icon>
	</button>
</mat-list-item>
